module.exports = __webpack_public_path__ + "static/ca-f11f911317fbf441e8adc8d15f93e5b4.svg";